(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["encuentra-tu-solucion"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.ets__grid-wrap').forEach(function (wrap) {
    var grid = wrap.querySelector('.ets__grid');
    var btns = wrap.querySelectorAll('[data-ets-arr]');
    if (!grid || !btns.length) return;
    grid.scrollLeft = 0;
    function update() {
      var max = grid.scrollWidth - grid.clientWidth - 2;
      btns.forEach(function (b) {
        var dir = parseInt(b.getAttribute('data-ets-arr'), 10);
        b.disabled = dir < 0 ? grid.scrollLeft <= 2 : grid.scrollLeft >= max;
      });
    }
    function positionArrows() {
      var media = grid.querySelector('.ets-card__media');
      if (!media) return;
      wrap.style.setProperty('--ets-arrow-top', media.offsetTop + media.offsetHeight / 2 + 'px');
    }
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        var card = grid.querySelector('.ets-card');
        var step = (card ? card.getBoundingClientRect().width : grid.clientWidth * 0.8) + 12;
        grid.scrollBy({ left: parseInt(b.getAttribute('data-ets-arr'), 10) * step, behavior: 'smooth' });
      });
    });
    grid.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', positionArrows);
    setTimeout(function () {
      update();
      positionArrows();
    }, 200);
    setTimeout(positionArrows, 600);
  });

  document.addEventListener('click', function (e) {
    var chip = e.target.closest('.ets__chip');
    if (!chip) return;
    var root = chip.closest('[data-ets-root]');
    if (!root) return;
    var id = chip.getAttribute('data-ets-tab');

    root.querySelectorAll('.ets__chip').forEach(function (c) {
      var on = c === chip;
      c.classList.toggle('is-active', on);
      c.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    root.querySelectorAll('.ets__panel').forEach(function (p) {
      var on = p.getAttribute('data-ets-panel') === id;
      p.classList.toggle('is-active', on);
      p.hidden = !on;
    });

    var activeGrid = root.querySelector('.ets__panel.is-active .ets__grid');
    if (activeGrid) {
      activeGrid.scrollLeft = 0;
      activeGrid.dispatchEvent(new Event('scroll'));
      var activeWrap = activeGrid.closest('.ets__grid-wrap');
      var activeMedia = activeGrid.querySelector('.ets-card__media');
      if (activeWrap && activeMedia) {
        activeWrap.style.setProperty('--ets-arrow-top', activeMedia.offsetTop + activeMedia.offsetHeight / 2 + 'px');
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slider"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function track(name, data) {
      if (typeof window.gtag === 'function') window.gtag('event', name, data);
      if (window.posthog && typeof window.posthog.capture === 'function') window.posthog.capture(name, data);
    }
    function slideData(slideEl) {
      var link = slideEl.querySelector('.sf-slider__link');
      return {
        position: Number(slideEl.getAttribute('data-slide')) + 1,
        slide_type: slideEl.getAttribute('data-slide-type') || '',
        link_url: link ? link.getAttribute('href') : '',
      };
    }
    document.addEventListener('click', function (e) {
      var link = e.target.closest('.sf-slider__link');
      if (!link) return;
      var slideEl = link.closest('.swiper-slide');
      if (!slideEl) return;
      track('home_banner_click', slideData(slideEl));
    });
    if ('IntersectionObserver' in window) {
      var seen = new WeakSet();
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting && !seen.has(entry.target)) {
              seen.add(entry.target);
              track('home_banner_impression', slideData(entry.target));
            }
          });
        },
        { threshold: 0.5 }
      );
      document
        .querySelectorAll('[data-section-type="slider"] .swiper-slide:not(.swiper-slide-duplicate)')
        .forEach(function (slideEl) {
          observer.observe(slideEl);
        });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
